"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStartOfDayFromStartDatePlusXDays = exports.getStartOfDayXFromToday = exports.dayOfWeekName = exports.mondayAndSundayOfWeek = exports.toDayOfWeekIsoFromJSDate = exports.addTimeStringToJSDate = exports.dateTo12Time = exports.dateTo24Time = exports.dateToEnglishDate = exports.addMinutesToTimeOfDay = exports.toTotalInMinutes = exports.subtractDurationToMomentTimeOfDay = exports.addDurationToMomentTimeOfDay = exports.toMomentDurationFromMinutes = exports.toMomentDuration = exports.toTimeOfDayString = exports.toMomentTimeOfDay = void 0;
const moment_1 = __importDefault(require("moment"));
/**
 * Converts a string "HH:mm" to moment time with format "HH:mm"
 * @param timeOfDay "HH:mm"
 * @returns a Moment
 */
const toMomentTimeOfDay = (timeOfDay) => moment_1.default(timeOfDay, "HH:mm");
exports.toMomentTimeOfDay = toMomentTimeOfDay;
/**
 * Formats the timeOfDayMoment to "HH:mm"
 * @param timeOfDayMoment as a Moment
 * @returns formatted to "HH:mm
 */
const toTimeOfDayString = (timeOfDayMoment) => timeOfDayMoment.format("HH:mm");
exports.toTimeOfDayString = toTimeOfDayString;
/**
 *  Returns a Moment Duration
 * @param incrementDuration as string "1:30" or Moment
 * @returns Moment Duration
 */
const toMomentDuration = (incrementMomentDuration) => {
    return moment_1.default
        .duration(incrementMomentDuration.hours(), "h")
        .add(incrementMomentDuration.minutes(), "m");
};
exports.toMomentDuration = toMomentDuration;
/**
 *  Returns a Moment Duration
 * @param duration as string minutes
 * @returns Moment Duration
 */
const toMomentDurationFromMinutes = (duration) => {
    return moment_1.default.duration(duration, "m");
};
exports.toMomentDurationFromMinutes = toMomentDurationFromMinutes;
/**
 * Takes a time of day "10:00" as moment and adds the increment duration "1:30" as moment. Returns "11:30"
 * @param startMomentTimeOfDay Moment representation of "10:00"
 * @param incrementMoment Moment representation of "1:30"
 * @returns Added duration formatted to "HH:mm
 */
const addDurationToMomentTimeOfDay = (startMomentTimeOfDay, incrementMoment) => {
    const endMomentTimeOfDay = startMomentTimeOfDay.add(incrementMoment);
    return endMomentTimeOfDay;
};
exports.addDurationToMomentTimeOfDay = addDurationToMomentTimeOfDay;
/**
 * Takes a time of day "10:00" as moment and subtracts the increment duration "1:30" as moment. Returns "11:30"
 * @param startMomentTimeOfDay Moment representation of "10:00"
 * @param incrementMoment Moment representation of "1:30"
 * @returns result after subtracting duration formatted to "HH:mm
 */
const subtractDurationToMomentTimeOfDay = (startMomentTimeOfDay, incrementMoment) => {
    const endMomentTimeOfDay = startMomentTimeOfDay.subtract(incrementMoment);
    return endMomentTimeOfDay;
};
exports.subtractDurationToMomentTimeOfDay = subtractDurationToMomentTimeOfDay;
/**
 * Accepts "HH:mm" format and converts it into minutes
 * @param timeOfDay
 * @returns total in minutes
 */
const toTotalInMinutes = (timeOfDay) => {
    const [hours, minutes] = timeOfDay.split(":");
    const totalInMinutes = parseInt(hours, 10) * 60 + parseInt(minutes, 10);
    return totalInMinutes;
};
exports.toTotalInMinutes = toTotalInMinutes;
/**
 * Accepts "HH:mm" and minutes as a number and returns "HH:mm" with the added minutes
 * @param timeOfDay
 * @param minutes
 */
const addMinutesToTimeOfDay = (timeOfDay, minutes) => {
    const timeOfDayMoment = exports.toMomentTimeOfDay(timeOfDay);
    const addedMinutes = timeOfDayMoment.add(minutes, "m");
    return exports.toTimeOfDayString(addedMinutes);
};
exports.addMinutesToTimeOfDay = addMinutesToTimeOfDay;
const dateToEnglishDate = (isoDate) => {
    const date = moment_1.default(isoDate);
    return date.format("dddd, MMMM Do YYYY");
};
exports.dateToEnglishDate = dateToEnglishDate;
/**
 * Accepts date string in ISO format and returns 24hr clock string
 * @param isoDate
 * @returns e.g. 13:15
 */
const dateTo24Time = (isoDate) => {
    const date = moment_1.default.utc(isoDate);
    return date.format("HH:mm");
};
exports.dateTo24Time = dateTo24Time;
/**
 * Accepts date string in ISO format and returns 12hr with am/pm
 * @param isoDate A
 * @returns e.g. 9:45 am or 5:15 pm
 */
const dateTo12Time = (isoDate) => {
    const date = moment_1.default.utc(isoDate);
    return date.format("h:mm a");
};
exports.dateTo12Time = dateTo12Time;
/**
 * Accepts a javascript date and a time string and adds them together
 * @param date
 * @param time
 * @returns a javascript date as a result
 */
const addTimeStringToJSDate = (date, time) => {
    const timeMoment = exports.toMomentTimeOfDay(time);
    const d = moment_1.default(date);
    const duration = moment_1.default
        .duration(timeMoment.hours(), "h")
        .add(moment_1.default.duration(timeMoment.minutes(), "m"));
    const final = d.add(duration);
    return final.toDate();
};
exports.addTimeStringToJSDate = addTimeStringToJSDate;
/**
 * Accepts a javascript date and returns a number for the day, where Mon = 1, Sun = 7
 * @param date
 * @returns the day of the week, 1-based, from Monday
 */
const toDayOfWeekIsoFromJSDate = (date) => {
    const momentDate = moment_1.default(date);
    return momentDate.isoWeekday();
};
exports.toDayOfWeekIsoFromJSDate = toDayOfWeekIsoFromJSDate;
/**
 * Accepts a javascript date and returns and object with the monday date and sunday date of that week
 * @param date
 * @returns sunday and monday date of that week
 */
const mondayAndSundayOfWeek = (date) => {
    const monday = moment_1.default(date).utc().startOf("isoWeek");
    const sunday = moment_1.default(date).utc().endOf("isoWeek");
    return {
        monday: monday.toDate(),
        sunday: sunday.toDate()
    };
};
exports.mondayAndSundayOfWeek = mondayAndSundayOfWeek;
/**
 * Accepts the iso week day index and returns the name of the day
 * @param dayOfWeek
 */
const dayOfWeekName = (dayOfWeek) => {
    return moment_1.default().isoWeekday(dayOfWeek).format("dddd");
};
exports.dayOfWeekName = dayOfWeekName;
/**
 * Returns a moment start of day of today + number of days
 * @param xDaysFromToday The number of days in the future from today.
 */
const getStartOfDayXFromToday = (xDaysFromToday) => {
    return moment_1.default().add(xDaysFromToday, "days").utc().startOf("day");
};
exports.getStartOfDayXFromToday = getStartOfDayXFromToday;
/**
 * Returns a moment start of day of start date + number of days
 * @startDate start Date
 * @xNumberOfDaysToAdd xDaysFromDayX The number of days in the future from day X.
 */
const getStartOfDayFromStartDatePlusXDays = (startDate, xNumberOfDaysToAdd) => {
    return moment_1.default(startDate)
        .add(xNumberOfDaysToAdd, "days")
        .utc()
        .startOf("day");
};
exports.getStartOfDayFromStartDatePlusXDays = getStartOfDayFromStartDatePlusXDays;
exports.default = {
    addMinutesToTimeOfDay: exports.addMinutesToTimeOfDay,
    toMomentTimeOfDay: exports.toMomentTimeOfDay,
    toTimeOfDayString: exports.toTimeOfDayString,
    addDurationToMomentTimeOfDay: exports.addDurationToMomentTimeOfDay,
    subtractDurationToMomentTimeOfDay: exports.subtractDurationToMomentTimeOfDay,
    toTotalInMinutes: exports.toTotalInMinutes,
    dateToEnglishDate: exports.dateToEnglishDate,
    dateTo24Time: exports.dateTo24Time,
    dateTo12Time: exports.dateTo12Time,
    addTimeStringToJSDate: exports.addTimeStringToJSDate,
    toDayOfWeekIsoFromJSDate: exports.toDayOfWeekIsoFromJSDate,
    mondayAndSundayOfWeek: exports.mondayAndSundayOfWeek,
    dayOfWeekName: exports.dayOfWeekName,
    getStartOfDayXFromToday: exports.getStartOfDayXFromToday,
    getStartOfDayFromStartDatePlusXDays: exports.getStartOfDayFromStartDatePlusXDays,
    toMomentDurationFromMinutes: exports.toMomentDurationFromMinutes
};
//# sourceMappingURL=timeUtil.js.map